// Module
var code = "<a href=\"javascript:;\" class=\"faq-items__faq-item\" ng-href=\"{{$ctrl.getFaqItemUrl(faqItem) | toOneDomain }}\" ng-repeat=\"faqItem in $ctrl.faqItems | limitTo:$ctrl.limitTo track by faqItem.id\"> <span ng-bind=\"::faqItem.question\"></span> <span class=\"material-icons-outlined md-18\">chevron_right</span> </a>";
// Exports
module.exports = code;